// extracted by mini-css-extract-plugin
export default {"extraCardStyle":"LocationCard_extraCardStyle__nzuyQ","map-img":"LocationCard_map-img__ONVgW","main-heading":"LocationCard_main-heading__LL8bT"};